<template>

  <v-container fluid>
    <v-form
      v-model="valid"
      ref="contactdetail"
      lazy-validation
    >
      <v-container fluid>
        <h4>Main Contact</h4>
        <v-layout
          row
          wrap
        >
          <v-flex
            lg3
            sm3
          >
            <v-text-field
              label="Email"
              prepend-icon="email"
              name="email"
              v-model="form.email"
            ></v-text-field>
          </v-flex>
          <v-flex
            lg3
            sm3
          >
            <v-text-field
              label="Phone"
              prepend-icon="phone"
              v-model="form.phone"
              name="phone"
              mask="###########"
            ></v-text-field>

          </v-flex>
          <v-flex
            lg3
            sm3
          >
            <v-text-field
              label="Fax"
              prepend-icon="scanner"
              v-model="form.fax"
              name="fax"
              mask="###########"
            ></v-text-field>

          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid>
        <h4>Main Address</h4>
        <v-layout
          row
          wrap
        >
          <v-flex
            lg3
            sm3
          >
            <v-text-field
              label="Address Line1"
              prepend-icon="location_city"
              v-model="form.address1"
              name="address1"
            ></v-text-field>
          </v-flex>
          <v-flex
            lg3
            sm3
          >

            <v-text-field
              label="Address Line2"
              placeholder=""
              prepend-icon="location_city"
              v-model="form.address2"
              name="address2"
            ></v-text-field>

          </v-flex>
          <v-flex
            lg3
            sm3
          >
            <v-text-field
              label="City"
              placeholder=""
              prepend-icon="location_city"
              v-model="form.city"
              name="city"
            ></v-text-field>

          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
        >
          <v-flex
            lg3
            sm3
          >
            <v-autocomplete
                      hint="Atleast 3 Characters required"               
                      chips                      
                      flat
                      placeholder="Select only suggested Country"
                      :items="countryItems"
                      v-model="form.countryID"
                      prepend-icon="assistant"
                      label="Country"
                      color="blue"
                      item-text="name"
                      item-value="countryID"
                      @change="stateSelect"
                    ></v-autocomplete>
          </v-flex>
          <v-flex
            lg3
            sm3
          >
            <v-autocomplete
                       hint="Atleast 3 Characters required"                
                      chips                     
                      flat
                      placeholder="Select only suggested State"
                      :items="filterStateItems"
                      v-model="form.stateID"
                      prepend-icon="assistant"
                      label="State"
                      color="blue"
                      item-text="name"
                      item-value="stateID"
                    ></v-autocomplete>

          </v-flex>
          <v-flex
            lg3
            sm3
          >

            <v-text-field
              label="Postal Code"
              placeholder=""
              prepend-icon="location_city"
              v-model="form.postalCode"
              name="postalCode"
              mask="######"
            ></v-text-field>

          </v-flex>
          
        </v-layout>
      </v-container>
      <v-container fluid>
        <h4>Personal Data Privacy</h4>
        <v-layout
          row
          wrap
        >
          <v-flex
            lg3
            sm3
          >
            <v-checkbox
              label="Is Data Privacy"
              v-model="form.isDataPrivacy"
            ></v-checkbox>
          </v-flex>
          <v-flex
            lg3
            sm3
          >

            <v-text-field
              label="Date of Consent"
              :error-messages="errors.collect('Date')"
              type="date"
              required
              prepend-icon="date_range"
              v-model="form.dateOfConsent"
            ></v-text-field>

          </v-flex>
          <v-flex
            lg3
            sm3
          >
            <v-text-field
              label="Consent Expires"
              :error-messages="errors.collect('Date')"
              type="date"
              required
              prepend-icon="date_range"
              v-model="form.consentExpires"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid>
        <h4>CRM</h4>
        <v-layout
          row
          wrap
        >
          <v-flex
            lg3
            sm3
          >
            <v-autocomplete              
              hint="Atleast 3 Characters required"      
              chips              
              flat
              placeholder="Select only suggested Contact Method"
              :items="contactMethodOptions"
              v-model="form.contactMethod"
              label="Contact Method"
              auto
              chips
              prepend-icon="person_pin"
              color="blue"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            lg3
            sm3
          >

            <v-text-field
              label="Account Reference#"
              placeholder=""
              prepend-icon="account_balance"
              v-model="form.accountReference"
              name="accountReference"
            ></v-text-field>

          </v-flex>
          <v-flex
            lg3
            sm3
          >
            <v-text-field
              v-model="form.parentAccount"
              label="Parent Account"
              prepend-icon="account_balance"
              name="parentAccount"
              mask="#############################"
            ></v-text-field>

          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex
            lg3
            sm3
          >
            <v-text-field
              label="Last Incoming Activity"
              placeholder=""
              prepend-icon="phone"
              v-model="form.inComingActivity"
              name="inComingActivity"
              mask="##################"
            ></v-text-field>
          </v-flex>
          <v-flex
            lg3
            sm3
          >

            <v-text-field
              label="Last Outgoing Activity"
              placeholder=""
              prepend-icon="phone"
              v-model="form.outGoingActivity"
              name="outGoingActivity"
              mask="##################"
            ></v-text-field>

          </v-flex>
          <v-flex
            lg3
            sm3
          >
            <v-text-field
              label="Company Name"
              placeholder=""
              prepend-icon="company"
              v-model="form.companyName"
              name="companyName"
            ></v-text-field>

          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid>
        <h4>Person</h4>
        <v-layout
          row
          wrap
        >
          <v-flex
            lg3
            sm3
          >
            <v-text-field
              label="Date of Birth"
              :error-messages="errors.collect('Date of Birth')"
              type="date"
              required
              prepend-icon="date_range"
              v-model="form.dOB"
              name="dOB"
            ></v-text-field>
          </v-flex>
          <v-flex
            lg3
            sm3
          >
            <v-text-field
              label="Spouse/Partner Name"
              placeholder=""
              prepend-icon="person"
              v-model="form.spouseName"
              name="spouseName"
            ></v-text-field>

          </v-flex>

          <v-flex
            lg3
            sm3
          >
            <h5> Gender</h5>
            <v-radio-group
              v-model="form.gender"
              prepend-icon="wc"
              name="gender"
            >
              <v-radio
                label="Male"
                value="yes-1"
              ></v-radio>
              <v-radio
                label="Female"
                value="No-1"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex
            lg3
            sm3
          >
            <h5> Marital Status</h5>
            <v-radio-group
              v-model="form.maritalStatus"
              prepend-icon="vpn_lock"
              name="maritalStatus"
            >
              <v-radio
                label="Married"
                value="yes-1"
              ></v-radio>
              <v-radio
                label="Unmarried"
                value="No-1"
              ></v-radio>
            </v-radio-group>
          </v-flex>

        </v-layout>
      </v-container>

    </v-form>
  </v-container>

</template>

<script>
import VWidget from '@/components/VWidget';
import { getContacts, getContact, getOwner, getCountries, getStates, createContact, updateContact, deleteContact } from '@/api/contact';
export default {
  components: {
    VWidget
  },
  $_veeValidate: {
    validator: 'new'
  },
  data: () => ({
    saveCard: true,

    valid: true,

    stateOptions: [],
    countryOptions: [],
    countryItems: [],
    filterStateItems: [],
    contactMethodOptions: [
      {
        id: 1,
        name: 'Phone'
      },
      {
        id: 2,
        name: 'E-mail'
      },
    ],
    form: {
      date: new Date().toISOString().substr(0, 10),
      loginUser: 'Arun',
      isLogin: 'yes-1',
      valid: false,
      contactID: 0,
      businessAccount: '',
      owner: '',
      firstName: '',
      lastName: '',
      workGroup: '',
      contactClass: '',
      jobTitle: '',
      status: '',
      type: '',
      email: '',
      phone: '',
      fax: '',
      address1: '',
      address2: '',
      city: '',
      stateID: -1,
      countryID: -1,
      postalCode: '',
      isDataPrivacy: '',
      dateOfConsent: new Date().toISOString().substr(0, 10),
      consentExpires: new Date().toISOString().substr(0, 10),
      contactMethod: '',
      accountReference: '',
      parentAccount: '',
      inComingActivity: '',
      outGoingActivity: '',
      companyName: '',
      dOB: new Date().toISOString().substr(0, 10),
      spouseName: '',
      gender: '',
      maritalStatus: '',
      lastAccessDate: '',
      addedByUserId: null,
      addedDate: new Date(),
      statusCodeId: 1,
      statusCode: 'Active',
      modifiedByUserId: null,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      contactActivities: [],

    }

  }),
  mounted () {
    this.$validator.localize('en', this.dictionary);
  },

  methods: {
    initialize () {
      this.loader = true;
      getCountries('')
        .then(response2 => {
          this.countryOptions = response2.data;
          this.$refs.contacttabs.$refs.contactdetail.countryOptions = this.countryOptions;
          this.loader = false;
          //this.total = response.data.length;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getStates('')
        .then(response3 => {
          this.stateOptions = response3.data;
          this.$refs.contacttabs.$refs.contactdetail.stateOptions = this.stateOptions;
          this.loader = false;
          //this.total = response.data.length;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    stateSelect (value) {
      // this.filterStateItems.index = -1;
      let uom = this.stateItems.filter(o => o.countryID == value);
      this.filterStateItems = uom;
    },
    submit () {
      this.$validator.validateAll();
    },
    clear () {
      this.form = {};
      this.$validator.reset();
    }
  }
};
</script>






// WEBPACK FOOTER //
// src/pages/contact/ContactDetail.vue